export default __webpack_public_path__ + "static/media/Spinner-0.7s-200px.024486fb.gif";